import buttons from "./buttons.json";
import tooltips from "./tooltips.json";
import table_headings from "./table-headings.json";
import menus from "./menus.json";
import badges from "./badges.json";
import payment_methods from "./payment-methods.json";
import transaction_types from "./transaction-types.json";
import pending_transactions from "./pending-transactions.json";
import auto_buttons from "../../../auto/locales/es/common/buttons.json";

export default {
  buttons,
  tooltips,
  table_headings,
  menus,
  badges,
  payment_methods,
  transaction_types,
  transactions: pending_transactions,
  auto_buttons,
};
